import React from 'react'

export const Subscribe = () => {
  return (
    <div id="mc_embed_signup">
      <form
        action="https://totalmilk.us9.list-manage.com/subscribe/post?u=48d02bddba88673c0a787615d&amp;id=1733713e68"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className=""
        target="_blank"
        noValidate={false}
      >
        <div id="mc_embed_signup_scroll">
          <input type="email" name="EMAIL" placeholder="Your email address" id="mce-EMAIL" />
          <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button btn btn-primary" />
        </div>
      </form>
    </div>
  )
}
